export function activateHints() {
    $(function () {
        $('[data-toggle="tooltip"]').tooltip("hide");
        $('[data-toggle="tooltip"]').tooltip()
    });


}